export default __webpack_public_path__ + "static/media/gallery_10.8cf329e6.jpg";